"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _ThreeMediaRightBottomTextLayout = require("./ThreeMediaRightBottomTextLayout");
Object.keys(_ThreeMediaRightBottomTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ThreeMediaRightBottomTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ThreeMediaRightBottomTextLayout[key];
        }
    });
});
